import { render, staticRenderFns } from "./RepartitionByDishTypeChart.vue?vue&type=template&id=3ffb3826&scoped=true&"
import script from "./RepartitionByDishTypeChart.vue?vue&type=script&lang=js&"
export * from "./RepartitionByDishTypeChart.vue?vue&type=script&lang=js&"
import style0 from "./RepartitionByDishTypeChart.vue?vue&type=style&index=0&id=3ffb3826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb3826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VContainer,VSwitch})
